export const SALARY_MIN_VALUE = 1;
export const SALARY_MAX_VALUE = 100000;
